/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.AckMsg = (function() {

    /**
     * Properties of an AckMsg.
     * @exports IAckMsg
     * @interface IAckMsg
     * @property {string|null} [guid] AckMsg guid
     * @property {number|null} [version] AckMsg version
     * @property {string|null} [refGuid] AckMsg refGuid
     * @property {string|null} [fromGuid] AckMsg fromGuid
     * @property {string|null} [targetGuid] AckMsg targetGuid
     * @property {AckMsg.MsgAckType|null} [ackState] AckMsg ackState
     * @property {AckMsg.Catalog|null} [catalog] AckMsg catalog
     */

    /**
     * Constructs a new AckMsg.
     * @exports AckMsg
     * @classdesc Represents an AckMsg.
     * @implements IAckMsg
     * @constructor
     * @param {IAckMsg=} [properties] Properties to set
     */
    function AckMsg(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AckMsg guid.
     * @member {string} guid
     * @memberof AckMsg
     * @instance
     */
    AckMsg.prototype.guid = "";

    /**
     * AckMsg version.
     * @member {number} version
     * @memberof AckMsg
     * @instance
     */
    AckMsg.prototype.version = 0;

    /**
     * AckMsg refGuid.
     * @member {string} refGuid
     * @memberof AckMsg
     * @instance
     */
    AckMsg.prototype.refGuid = "";

    /**
     * AckMsg fromGuid.
     * @member {string} fromGuid
     * @memberof AckMsg
     * @instance
     */
    AckMsg.prototype.fromGuid = "";

    /**
     * AckMsg targetGuid.
     * @member {string} targetGuid
     * @memberof AckMsg
     * @instance
     */
    AckMsg.prototype.targetGuid = "";

    /**
     * AckMsg ackState.
     * @member {AckMsg.MsgAckType} ackState
     * @memberof AckMsg
     * @instance
     */
    AckMsg.prototype.ackState = 0;

    /**
     * AckMsg catalog.
     * @member {AckMsg.Catalog} catalog
     * @memberof AckMsg
     * @instance
     */
    AckMsg.prototype.catalog = 0;

    /**
     * Creates a new AckMsg instance using the specified properties.
     * @function create
     * @memberof AckMsg
     * @static
     * @param {IAckMsg=} [properties] Properties to set
     * @returns {AckMsg} AckMsg instance
     */
    AckMsg.create = function create(properties) {
        return new AckMsg(properties);
    };

    /**
     * Encodes the specified AckMsg message. Does not implicitly {@link AckMsg.verify|verify} messages.
     * @function encode
     * @memberof AckMsg
     * @static
     * @param {IAckMsg} message AckMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AckMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.guid != null && message.hasOwnProperty("guid"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.guid);
        if (message.version != null && message.hasOwnProperty("version"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.version);
        if (message.refGuid != null && message.hasOwnProperty("refGuid"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.refGuid);
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.fromGuid);
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.targetGuid);
        if (message.ackState != null && message.hasOwnProperty("ackState"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.ackState);
        if (message.catalog != null && message.hasOwnProperty("catalog"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.catalog);
        return writer;
    };

    /**
     * Encodes the specified AckMsg message, length delimited. Does not implicitly {@link AckMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AckMsg
     * @static
     * @param {IAckMsg} message AckMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AckMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AckMsg message from the specified reader or buffer.
     * @function decode
     * @memberof AckMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AckMsg} AckMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AckMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AckMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.guid = reader.string();
                break;
            case 2:
                message.version = reader.int32();
                break;
            case 3:
                message.refGuid = reader.string();
                break;
            case 4:
                message.fromGuid = reader.string();
                break;
            case 5:
                message.targetGuid = reader.string();
                break;
            case 6:
                message.ackState = reader.int32();
                break;
            case 7:
                message.catalog = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AckMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AckMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AckMsg} AckMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AckMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AckMsg message.
     * @function verify
     * @memberof AckMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AckMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.guid != null && message.hasOwnProperty("guid"))
            if (!$util.isString(message.guid))
                return "guid: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.refGuid != null && message.hasOwnProperty("refGuid"))
            if (!$util.isString(message.refGuid))
                return "refGuid: string expected";
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            if (!$util.isString(message.fromGuid))
                return "fromGuid: string expected";
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            if (!$util.isString(message.targetGuid))
                return "targetGuid: string expected";
        if (message.ackState != null && message.hasOwnProperty("ackState"))
            switch (message.ackState) {
            default:
                return "ackState: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 99:
                break;
            }
        if (message.catalog != null && message.hasOwnProperty("catalog"))
            switch (message.catalog) {
            default:
                return "catalog: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        return null;
    };

    /**
     * Creates an AckMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AckMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AckMsg} AckMsg
     */
    AckMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.AckMsg)
            return object;
        var message = new $root.AckMsg();
        if (object.guid != null)
            message.guid = String(object.guid);
        if (object.version != null)
            message.version = object.version | 0;
        if (object.refGuid != null)
            message.refGuid = String(object.refGuid);
        if (object.fromGuid != null)
            message.fromGuid = String(object.fromGuid);
        if (object.targetGuid != null)
            message.targetGuid = String(object.targetGuid);
        switch (object.ackState) {
        case "ACK_TYPE_UNKNOWN":
        case 0:
            message.ackState = 0;
            break;
        case "CLIENT_SEND_FAIL":
        case 1:
            message.ackState = 1;
            break;
        case "CLIENT_SEND_OK":
        case 2:
            message.ackState = 2;
            break;
        case "SERVER_WILL_FORWARD":
        case 3:
            message.ackState = 3;
            break;
        case "CLIENT_TO_FORWARD":
        case 4:
            message.ackState = 4;
            break;
        case "SERVER_FORWARD_OK":
        case 5:
            message.ackState = 5;
            break;
        case "CLIENT_RECEIVE":
        case 6:
            message.ackState = 6;
            break;
        case "FORWARD_OK":
        case 7:
            message.ackState = 7;
            break;
        case "CLIENT_INTRRRUPT":
        case 99:
            message.ackState = 99;
            break;
        }
        switch (object.catalog) {
        case "CATALOG_UNKNOWN":
        case 0:
            message.catalog = 0;
            break;
        case "MSG":
        case 1:
            message.catalog = 1;
            break;
        case "PACKAGE":
        case 2:
            message.catalog = 2;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from an AckMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AckMsg
     * @static
     * @param {AckMsg} message AckMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AckMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.guid = "";
            object.version = 0;
            object.refGuid = "";
            object.fromGuid = "";
            object.targetGuid = "";
            object.ackState = options.enums === String ? "ACK_TYPE_UNKNOWN" : 0;
            object.catalog = options.enums === String ? "CATALOG_UNKNOWN" : 0;
        }
        if (message.guid != null && message.hasOwnProperty("guid"))
            object.guid = message.guid;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.refGuid != null && message.hasOwnProperty("refGuid"))
            object.refGuid = message.refGuid;
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            object.fromGuid = message.fromGuid;
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            object.targetGuid = message.targetGuid;
        if (message.ackState != null && message.hasOwnProperty("ackState"))
            object.ackState = options.enums === String ? $root.AckMsg.MsgAckType[message.ackState] : message.ackState;
        if (message.catalog != null && message.hasOwnProperty("catalog"))
            object.catalog = options.enums === String ? $root.AckMsg.Catalog[message.catalog] : message.catalog;
        return object;
    };

    /**
     * Converts this AckMsg to JSON.
     * @function toJSON
     * @memberof AckMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AckMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * MsgAckType enum.
     * @name AckMsg.MsgAckType
     * @enum {string}
     * @property {number} ACK_TYPE_UNKNOWN=0 ACK_TYPE_UNKNOWN value
     * @property {number} CLIENT_SEND_FAIL=1 CLIENT_SEND_FAIL value
     * @property {number} CLIENT_SEND_OK=2 CLIENT_SEND_OK value
     * @property {number} SERVER_WILL_FORWARD=3 SERVER_WILL_FORWARD value
     * @property {number} CLIENT_TO_FORWARD=4 CLIENT_TO_FORWARD value
     * @property {number} SERVER_FORWARD_OK=5 SERVER_FORWARD_OK value
     * @property {number} CLIENT_RECEIVE=6 CLIENT_RECEIVE value
     * @property {number} FORWARD_OK=7 FORWARD_OK value
     * @property {number} CLIENT_INTRRRUPT=99 CLIENT_INTRRRUPT value
     */
    AckMsg.MsgAckType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ACK_TYPE_UNKNOWN"] = 0;
        values[valuesById[1] = "CLIENT_SEND_FAIL"] = 1;
        values[valuesById[2] = "CLIENT_SEND_OK"] = 2;
        values[valuesById[3] = "SERVER_WILL_FORWARD"] = 3;
        values[valuesById[4] = "CLIENT_TO_FORWARD"] = 4;
        values[valuesById[5] = "SERVER_FORWARD_OK"] = 5;
        values[valuesById[6] = "CLIENT_RECEIVE"] = 6;
        values[valuesById[7] = "FORWARD_OK"] = 7;
        values[valuesById[99] = "CLIENT_INTRRRUPT"] = 99;
        return values;
    })();

    /**
     * Catalog enum.
     * @name AckMsg.Catalog
     * @enum {string}
     * @property {number} CATALOG_UNKNOWN=0 CATALOG_UNKNOWN value
     * @property {number} MSG=1 MSG value
     * @property {number} PACKAGE=2 PACKAGE value
     */
    AckMsg.Catalog = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "CATALOG_UNKNOWN"] = 0;
        values[valuesById[1] = "MSG"] = 1;
        values[valuesById[2] = "PACKAGE"] = 2;
        return values;
    })();

    return AckMsg;
})();

module.exports = $root;
